import { useEffect, useState } from 'react';

const revokeObjectUrl = (url: string | null) => {
  if (url?.startsWith('blob:')) {
    URL.revokeObjectURL(url);
  }
};

export const useProfileImageState = (initialUrl: string | null = null) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(initialUrl);
  const [removed, setRemoved] = useState(false);

  useEffect(() => {
    setRemoved(false);
    setPreviewUrl((currentUrl) => {
      if (currentUrl === initialUrl) return currentUrl;

      revokeObjectUrl(currentUrl);
      return initialUrl;
    });
  }, [initialUrl]);

  useEffect(() => {
    return () => revokeObjectUrl(previewUrl);
  }, [previewUrl]);

  const selectFile = (file: File | null) => {
    if (!file) return;

    setSelectedFile(file);
    setRemoved(false);
    setPreviewUrl((currentUrl) => {
      revokeObjectUrl(currentUrl);
      return URL.createObjectURL(file);
    });
  };

  const remove = () => {
    setSelectedFile(null);
    setRemoved(true);
    setPreviewUrl((currentUrl) => {
      revokeObjectUrl(currentUrl);
      return null;
    });
  };

  const reset = (nextUrl: string | null) => {
    setSelectedFile(null);
    setRemoved(false);
    setPreviewUrl((currentUrl) => {
      revokeObjectUrl(currentUrl);
      return nextUrl;
    });
  };

  return {
    selectedFile,
    previewUrl,
    removed,
    selectFile,
    remove,
    reset,
  };
};
